export const emptySettings = {
	color: '',
	backgroundColor: '',
	rounded: '',
	buttonColor: '',
	buttonBackground: '',
	buttonBackground2: '',
	buttonBackground3: '',
	headingColor: '',
	headingColor2: '',
	headingColor3: '',
	fontSize: '',
	headingFontSize: '',
	fontFamily: '',
	buttonRounded: '',
	buttonBorderWidth: '',
	buttonBorderColor: '',
	buttonPaddingTop: '8',
	buttonPaddingLeft: '16',
	buttonPaddingBottom: '8',
	buttonPaddingRight: '16',
	cardColor: '',
	cardBackground: '',
	cardBackground2: '',
	cardBackground3: '',
	cardRounded: '',
	cardBorderWidth: '',
	cardBorderColor: '',
	cardPaddingTop: '16',
	cardPaddingLeft: '16',
	cardPaddingBottom: '16',
	cardPaddingRight: '16',
	gtmId: '',
	headingFontFamily: '',
	parse: 'true',
	salutation: 'true',
	icon: '',
	customerName: '',
};

export const resolveSetting = (value, settings) => {
	if (!settings) {
		return value;
	}
	return settings[value] ?? emptySettings[value] ?? value;
};

export const isEmpty = (value) => value === undefined || value === '' || value === null;

export const getBackgroundProp = (props, settings) => {
	const { background, background2, background3, bgGradientDirection } = props;
	if (isEmpty(resolveSetting(background2, settings))) {
		return resolveSetting(background, settings);
	}
	const colors = [
		resolveSetting(background, settings),
		resolveSetting(background2, settings),
	];
	if (!isEmpty(resolveSetting(background3, settings))) {
		colors.push(resolveSetting(background3, settings));
	}
	return `linear-gradient(${bgGradientDirection || 'to right'}, ${colors.join(', ')})`;
};
